module.exports = __webpack_public_path__ + "img/women-looking-stock.f2c89e7c.jpeg";